<template>
  <div class="body" style="margin-top: 50px">
    <!-- <h1>
            <img class="back" onclick="backToAppCallBack()" src="./images/nav_back.png" alt="">
            用户协议
            <span class="empty"></span>
        </h1> -->
    <h2>I 特别提示</h2>
    <ul>
      <li>
        A.
        “友邻少年”软件及相关服务，系指公司通过合法拥有并运营的、标注名称为“友邻少年”的客户端应用程序及网站（ylyk.com），向您提供的产品与服务，包括但不限于课程学习、搜索查询等核心功能以及其他功能。《用户协议》（以下称“本协议”）由您与北京每日友邻文化科技有限公司（以下称“本公司”）共同签订。
      </li>
      <li>
        B. 您在申请注册流程中点击同意本协议之前，应当认真阅读本协议，并审慎选择接受或不接受本协议。
        <u>
          <b>
            请您务必审慎阅读、充分理解各条款内容，并重点阅读与您约定免除或者限制责任的条款、约定法律适用和争议解决的条款、及其他以粗体下划线标识的重要条款。
          </b>
        </u>
        本协议有助于您了解本公司为您提供的服务内容及您使用服务的权利和义务。如您对本协议条款有任何疑问，您可通过客服电话010-62565909进行咨询。
      </li>
      <li>
        C.
        当您按照注册页面提示填写信息、阅读并点击同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与本公司达成一致，成为本协议所涉服务的“用户”。
        <u>
          <b>
            您的注册、登录、使用等事实行为均将视为对本协议的完全接受。本协议自您接受之时起生效并成为您与北京每日友邻文化科技有限公司之间直接有约束力的法律文件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册、登录或使用本协议所涉服务。
          </b>
        </u>
      </li>
    </ul>
    <h2>II 相关服务</h2>
    <ul>
      <li>
        A.
        本协议所涉服务均由友邻少年平台根据实际情况提供，例如在线课程、直播课各类服务等，平台有权新增、变更任一课程的讲师及课程内容；对于课程主要讲师发生变更的信息，本公司将及时在官网及APP上予以公告说明，或通过其他合理有效方式通知用户。
      </li>
      <li>
        B.
        友邻少年提供的部分网络服务为收费的网络服务，用户使用收费网络服务需要向友邻少年支付一定的费用。对于收费的网络服务，友邻少年会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则友邻少年有权不向用户提供该等收费网络服务。
      </li>
      <li>
        C.
        用户理解，友邻少年仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。
      </li>
    </ul>
    <h2>III 关于账号</h2>
    <ul>
      <li>
        A. 您使用友邻少年的部分功能（含课程服务）前需要有一个成功注册的微信账户，并获得该微信账户的授权，
        <u>
          <b>
            授权内容包括但不限于：获得该微信账户的公开信息（昵称、头像等），寻找与你共同使用该应用的微信好友，帮助你分享信息到朋友圈等。对于你的微信账户信息，本公司不会擅自非法利用、透露或公开。用户有责任妥善保管你的微信账户信息及帐户密码的安全，因您自身因素导致微信账户及密码泄露，而造成的本服务下相关信息的泄露、篡改、删除等后果，本公司不承担任何责任。
          </b>
        </u>
      </li>
      <li>
        B.
        <u>
          <b>
            您有责任维护个人账号的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在“友邻少年”软件及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。您应高度重视对账号的保密，若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知公司。
          </b>
        </u>
      </li>
      <li>
        C. 用户资料
        <br />
        <span class="indent">
          用户在使用友邻少年服务时填写、登录、使用的帐号名称、头像、个人简介等帐号信息资料应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息，且用户保证在填写、登录、使用帐号信息资料时，不得有以下情形：
        </span>
        <ul class="indent">
          <li>1. 违反宪法或法律法规规定的；</li>
          <li>2. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
          <li>3. 损害国家荣誉和利益的，损害公共利益的；</li>
          <li>4. 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
          <li>5. 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
          <li>6. 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
          <li>7. 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
          <li>8. 侮辱或者诽谤他人，侵害他人合法权益的；</li>
          <li>9. 含有法律、行政法规禁止的其他内容的。</li>
        </ul>
      </li>
      <li>
        D.
        若用户登录、使用帐号头像、个人简介等帐号信息资料存在违法和不良信息的，友邻少年有权采取通知限期改正、暂停使用等措施。对于冒用关联机构或社会名人登录、使用、填写帐号名称、头像、个人简介的，友邻少年有权取消该帐号在友邻少年上使用，并向政府主管部门进行报告。
      </li>
    </ul>
    <h2>IV 用户隐私政策</h2>
    <ul>
      <li>
        <u><b>您充分了解并同意，本公司将按以下约定条款及隐私政策</b></u>
        对您的个人信息进行收集、存储、使用、披露和保护。“个人信息”包括但不限于用户的姓名、性别、年龄、出生日期、电话号码、手机软硬件信息、手机识别码等以及法律、法规、规范性文件规定的其他个人信息。
      </li>
      <li>
        A. 共享
        <ul class="indent">
          <li>
            1. 共享原则
            <ul class="indent">
              <li>
                a.
                <u><b>授权同意原则：</b></u>
                向我们的关联方、第三方共享您的个人信息，需经过您的授权同意，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果关联方、第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。
              </li>
              <li>
                b.
                <u><b>合法正当与最小必要原则：</b></u>
                向关联方、第三方共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。
              </li>
              <li>
                c.
                <u><b>安全审慎原则：</b></u>
                我们将审慎评估关联方、第三方数据使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
                <h3>
                  <u><a class="link" href="userAgreementSDKList.html">《第三方SDK目录》</a></u>
                </h3>
              </li>
            </ul>
          </li>
          <li>
            2. 实现功能或服务的共享信息
            <ul class="indent">
              <li>
                a.
                当您在使用友邻少年中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供服务时我们会将
                <u><b>实现业务所必需的的信息</b></u>
                与这些关联方、第三方共享，以向您进行推荐、展示或推送您可能感兴趣的信息，或者推送更适合您的特定功能、服务。
              </li>
              <li>
                b. 支付功能：支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要收集您的姓名、
                <u><b>银行卡类型及卡号、有效期及手机号码。银行卡号、有效期及手机号码</b></u>
                是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。
              </li>
              <li>
                c.
                为与您使用的终端机型适配消息推送功能，我们可能会通过SDK等技术与终端设备制造商（华为、小米、OPPO、VIVO等）共享手机型号、版本及相关设备信息。
              </li>
            </ul>
          </li>
          <li>
            3. 实现安全与分析统计的共享信息
            <ul class="indent">
              <li>
                a.
                保障使用安全：我们非常重视账号与服务安全，为保障您和其他用户的账号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联公司或服务提供商可能会共享必要的设备、账号及日志信息。
              </li>
              <li>
                b.
                分析产品使用情况：为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。
              </li>
            </ul>
          </li>
          <li>
            4. 帮助您参加营销推广活动
            <ul class="indent">
              <li>
                当您选择参加我们及我们的关联方或第三方举办的有关营销活动时，可能需要您提供
                <u><b>姓名、通信地址、联系方式、银行账号</b></u>
                信息。
                <u><b>这些信息是敏感个人信息</b></u>
                ，
                拒绝提供可能会影响您参加相关活动，但不会影响其他功能。只有经过您的同意，我们才会将这些信息与关联方或第三方共享，以保障您在联合活动中获得体验一致的服务，或委托第三方及时向您兑现奖励。
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        B. 转让
        <ul class="indent">
          <li>1. 我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。</li>
          <li>
            2.
            随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。
          </li>
        </ul>
      </li>
      <li>
        C. 披露
        <ul class="indent">
          <li>
            1.
            我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施.
          </li>
          <li>
            2.
            <u><b>对违规账号、欺诈行为进行处罚公告时，我们会披露相关账号的信息。</b></u>
          </li>
        </ul>
      </li>
      <li>
        D. 依法豁免征得同意共享、转让、公开披露的个人信息
        <ul class="indent">
          <li>
            请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：
            <ul class="indent">
              <li>1. 与国家安全、国防安全直接相关的；</li>
              <li>2. 与公共安全、公共卫生、重大公共利益直接相关的；</li>
              <li>3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
              <li>4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
              <li>5. 您自行向社会公众公开的个人信息；</li>
              <li>6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        E. 我们如何保护个人信息的安全
        <ul class="indent">
          <li>
            1.
            我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。
          </li>
          <li>
            2.
            我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。
          </li>
          <li>
            3.
            我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。
          </li>
          <li>
            4.
            <u>
              <b>
                尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。
              </b>
            </u>
          </li>
          <li>
            5.
            <u>
              <b>
                您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。
              </b>
            </u>
          </li>
          <li>
            6.
            我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。
          </li>
          <li>
            7.
            <u>
              <b>
                您一旦离开“友邻少年”及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在友邻少年及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于“友邻少年”的链接或引导。
              </b>
            </u>
          </li>
        </ul>
      </li>
      <li>
        F.
        <u><b>本公司在下述情形下</b></u>
        可使用您的
        <u><b>个人信息：</b></u>
        <ul class="indent">
          <li>1. 在紧急情况下，为维护用户及公众的权益；</li>
          <li>2. 为维护本公司友邻少年的著作权、商标权、专利权及其他任何合法权利或权益；</li>
          <li>
            3.
            在进行促销或抽奖时，本公司可能会与赞助商共享用户的个人信息，在这些情况下友邻少年会在发送用户信息之前进行提示，并且用户可以通过明确表示不参与活动而终止传送过程
          </li>
          <li>4. 为获取第三方数据而将用户信息与第三方数据匹配；</li>
          <li>
            5. 将用户数据用于统计，以便向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述友邻少年的服务。
          </li>
        </ul>
      </li>
      <li>
        G. 用户知悉并同意以下用户
        <u><b>隐私制度</b></u>
        <ul class="indent">
          <li>
            1.
            为便于向用户提供更好的服务，本公司将在用户自愿选择服务或者提供信息的情况下收集用户的个人信息，并将这些信息进行整合。
          </li>
          <li>
            2.
            在用户使用本协议所涉服务时，服务器会自动记录相关信息，包括但不限于URL、IP地址、浏览器类型、使用语言、访问日期和时间等。
          </li>
          <li>
            3.
            为方便用户登录或使用本协议所涉服务，本公司在有需要时将使用cookies等技术，并将收集到的信息发送到对应的服务器。用户可以选择接受或者拒绝cookies。如用户选择拒绝cookies，则用户有可能无法登录或使用依赖于cookies的服务或者功能。
          </li>
          <li>
            4.
            本公司收集的信息将成为本公司常规商业档案的一部分，且有可能因为转让、合并、收购、重组等原因而被转移到本公司的继任公司或者指定的一方。本公司同意善意使用收集的信息，且采取各项措施保证信息安全。
          </li>
        </ul>
      </li>
      <li>
        H. 尊重用户个人隐私是本公司的基本政策。
        <u>
          <b>
            本公司不会非法公开或透露用户的注册资料及保存在友邻少年相关服务中的非公开内容，但您同意本公司有权在以下任一情况下有权公开或透露相关信息：
          </b>
        </u>
        <ul class="indent">
          <li>1. 事先获得用户的明确授权。</li>
          <li>
            2.
            遵守有关法律规定，包括但不限于在国家有关机关查询时，提供用户的注册信息、用户在友邻少年上发布的信息内容及其发布时间、互联网地址或者域名。
          </li>
          <li>3. 保持维护本公司的知识产权和其他重要权利。</li>
          <li>4. 在紧急情况下竭力维护用户个人和社会大众的隐私安全</li>
          <li>5. 根据本协议相关规定或者本公司认为必要的其他情况。</li>
        </ul>
      </li>
      <li>
        I.
        <u><b>您同意，在本公司</b></u>
        与第三方共同合作向用户提供友邻少年相关服务的
        <u><b>情况下，如该第三方同意承担与本公司同等的保护用户隐私的责任，则本公司可将用户信息提供给该第三方。</b></u>
      </li>
    </ul>
    <h2>V 用户行为规范</h2>
    <ul>
      <li>
        A. 充分授权
        <ul class="indent">
          <li>
            1.
            请确认您依照中华人民共和国法律法规（包括法律、行政法规、部门规章、规范性文件等相关规定，下同）、您所在地之法律法规及您自愿或应当接收其管辖之法律法规（以下合称“法律”），有权签署并同意接受本协议的约束。
          </li>
          <li>
            2.
            如果您为无民事行为能力人或为限制民事行为能力人，请告知您的监护人，并承诺在您监护人的指导下阅读本协议和使用本协议所涉服务。
          </li>
          <li>3. 如果您代表您的雇主或单位，请在签署前，确认并保证您已获得签署本协议的充分授权。</li>
        </ul>
      </li>
      <li>
        B. 善意使用
        <ul class="indent">
          <li>
            您同意，遵守法律及本协议规定，秉承善意合法使用友邻少年，且保证：
            <ul class="indent">
              <li>
                1.
                不会利用友邻少年从事侵害他人合法权益之行为或违反国家法律法规；不会以非法方式获取或利用友邻少年的用户信息。
              </li>
              <li>
                2.
                不会未经许可使用友邻少年的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由北京每日友邻文化科技有限公司（及关联方）或友邻少年享有知识产权或权益的信息或资料；不会侵犯北京每日友邻文化科技有限公司（及关联方）或友邻少年的商标权、著作权、专利权、其他知识产权或其他合法权利或权益；不会以任何方式贬损北京每日友邻文化科技有限公司（及关联方）或友邻少年的商业声誉。
              </li>
              <li>
                3.
                不会以技术方式攻击、破坏或改变友邻少年的部分或全部，或干扰其运行；不会以非法方式获取或使用友邻少年的任何软件、代码、其他技术或商业信息；不会对友邻少年运行的任何程序进行反向工程、反向编译、反向汇编或改写。
              </li>
              <li>
                4.
                不会利用友邻少年进行其他违背公序良俗的活动。您使用友邻少年的记录，可能被保存作为对您不利的证据。因诉讼、仲裁或者案件侦查之需求本公司也可能将您违反法律法规或侵犯第三方权利或权益的记录报告给行政主管部门、司法机关。
              </li>
              <li>
                5. 用户产生的内容
                <ul class="indent">
                  <li>
                    a.
                    用户在友邻少年以各种形式发布的一切信息，均应符合国家法律法规等相关规定及友邻少年相关规定，符合社会公序良俗，并不得侵犯任何第三方主体的合法权益。友邻少年有权随时检查您所上传的内容，如果发现您上传的内容不符合前述规定，友邻少年有权删除或重新编辑或修改您所上传的内容。
                  </li>
                  <li>
                    b. 友邻少年有权对用户上传的内容进行检查、编辑与修改。但是
                    <u>
                      <b>
                        对于用户通过友邻少年传播的内容，北京每日友邻文化科技有限公司（及关联方）或友邻少年不保证其合法性、正当性、准确性或完整性，用户应自行承担因此产生的一切法律后果。在任何情况下，北京每日友邻文化科技有限公司（及关联方）或友邻少年均不对任何用户上传内容承担任何责任，包括但不限于由于任何用户上传内容而导致的直接或间接损失。
                      </b>
                    </u>
                    北京每日友邻文化科技有限公司（及关联方）或友邻少年因此受到的损失，有权向用户追偿
                  </li>
                  <li>
                    c.
                    友邻少年将尽可能保存用户上传的合法内容，但不承诺将为用户保存其上传的内容，用户应自行就前述内容备份。
                  </li>
                  <li>
                    d. 用户不得利用友邻少年服务制作、上载、复制、发布、传播或者转载如下内容：
                    <ul class="indent">
                      <li>i. 反对宪法所确定的基本原则的；</li>
                      <li>ii. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
                      <li>iii. 损害国家荣誉和利益的；</li>
                      <li>iv. 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                      <li>v. 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                      <li>vi. 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
                      <li>vii. 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
                      <li>viii. 侮辱或者诽谤他人，侵害他人合法权益的；</li>
                      <li>ix. 含有法律、行政法规禁止的其他内容的信息。</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        C. 第三方内容
        <ul class="indent">
          <li>
            <u>
              <b>
                您了解并同意，友邻少年可能存在大量由第三方享有权利的内容，您不得违反法律或本协议规定传播、使用任何您未享有完整、合法权利的内容。包括但不限于以下约定事项：
              </b>
            </u>
            <ul class="indent">
              <li>1. 本公司有权随时依其自身判断认定您不应传播的第三方内容。</li>
              <li>
                2.
                您应自行对从友邻少年获悉或获取的第三方内容进行分析、甄别、判断、依法使用并合理预防其可能存在的各种风险。
              </li>
              <li>
                3.
                友邻少年有权（但无义务）对第三方内容进行审慎核查，但不保证您接受的任何第三方内容具有合法性、真实性、准确性或安全性，也不保证其构成任何可靠的或全面的知识系统，也不对因存储或传送第三方内容过程中产生的延误、错误、遗漏、不准确、或由此产生的任何直接或间接损害，由您赔偿、补偿或承担法律责任。
              </li>
              <li>
                4.
                友邻少年课程援引的第三方素材的版权归属于原平台或者原著作权人，您不因购买友邻少年课程而享有第三方素材的版权；若您对友邻少年援引的第三方素材内容感兴趣，建议您购买原版。
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        D. 非商业使用
        <ul class="indent">
          <li>
            您同意，仅以非商业目的使用友邻少年；不对友邻少年的任何部分或全部进行商业性质利用、复制、拷贝、出售、调查、广告，或将友邻少年用于其他任何商业目的或商业性质的活动；但本公司与您另行签订有协议或本公司另行指定可供您使用的特定商业服务除外。
          </li>
        </ul>
      </li>
    </ul>
    <h2>VI 收费条款</h2>
    <ul>
      <li>
        友邻少年会员服务是本公司向注册用户提供的一项收费服务。您须先成为友邻少年普通注册用户之后，才能继续购买会员套餐；在您通过购买程序支付会员套餐标示的费用后，您即可成为会员，并享受所购套餐内提供的包括友邻少年收费课程在内的各项会员服务。在您决定购买之前，请仔细阅读本协议收费条款。
        <u>
          <b>
            您通过购买程序支付会员套餐服务费用或使用会员服务的行为，将视为您完全同意并接受以下服务条款；若您不同意或不接受以下任一服务条款，请您立即停止购买行为并停止使用会员服务。
          </b>
        </u>
        <ul class="indent">
          <li>
            A. 协议条款的确认和接受
            <ul class="indent">
              <li>
                1.
                友邻少年将根据本协议收费条款为您提供会员服务。您在享受友邻少年会员服务时必须完全、严格遵守本协议收费条款。
              </li>
              <li>
                2.
                友邻少年根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地优化服务质量并修改完善服务条款。友邻少年有权就本协议服务条款进行随时更新，且毋须另行通知。您的权利以及义务的表述、购买程序及收费标准，均以最新的服务条款为准。您如果不同意该服务条款的修改，不影响您对已发生责任及义务的承担；如果您在服务条款变更后继续访问或使用友邻少年，则视为您已经同意并接受相应修改。
              </li>
              <li>
                3.
                您在进行购买程序过程中点击"立即支付"等同类支付按钮即表示您已仔细阅读并完全接受本协议下第五条的全部条款。当您根据提示确认愿意支付相关费用，并通过本协议下第VI条第E款约定方式中的任一方式支付费用后，您才能使用会员服务。如您拒绝支付该等费用，则不能使用包括收费课程在内的相关会员服务。
              </li>
              <li>4. 您仅对本公司于友邻少年中标记供会员收听、观看、下载等服务或者内容享受使用权。</li>
              <li>
                5.
                根据本协议规定，您一旦购买友邻少年提供的会员服务，即视为您是符合中华人民共和国法律规定的具有完全民事权利能力和完全民事行为能力且能够独立承担民事责任的自然人，并充分了解及同意本协议的全部内容以及友邻少年对本协议随时所做的任何修改。
              </li>
            </ul>
          </li>
          <li>
            B. 风险及责任
            <ul class="indent">
              <li>
                1.
                您须对自身在使用友邻少年会员服务时的一切行为、行动（不论是否故意）负完全责任。因您前述行为而导致的您自身或其他任何第三方的任何损失或损害，本公司不承担责任。
              </li>
              <li>
                2.
                您应自行负责妥善且正确地保管、使用、维护其在友邻少年申请取得的账户及账户密码，并对其账户密码采取必要和有效的保密措施。非本公司之原因致使您账户密码泄露以及因您保管、使用、维护不当造成损失的，本公司无须承担与此有关的任何责任。
              </li>
              <li>
                3.
                您承诺不将您的账号、密码转让、出借或以任何脱离您控制的形式交由他人使用。如发现您的账号遭他人非法使用，您可通过拨打友邻少年官方电话或在友邻少年APP内意见反馈页面立即通知本公司。如因您私自出借或转让账号的行为而侵害本公司及相关权利人的权益时，您需承担相关责任，并赔偿经济损失。
                您明确了解并同意，本协议下第VI条第E款约定的付费方式为代收费运营商（如：微信支付、支付宝、京东支付等）托收的，您选用此种付费方式可能存在一定的商业风险（包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动），并可能给您造成相应的经济损失。为此，您同意本公司及本公司关联方在充分履行其在本协议项下全部义务及勤勉谨慎义务的前提下，不对您的前述风险和损失承担任何责任；并且，本公司及本公司关联方不承担向不法分子追究侵权责任或者代其向您承担损失的任何责任和义务。
              </li>
              <li>
                4.
                您对本服务条款及修改有任何异议，可选择放弃您的会员资格并停止使用会员课程服务，但本公司不退还任何您已缴纳的收费费用。
              </li>
              <li>5. 对于您购买的会员服务下的课程内容，您只可以私人收听、观看，不得用于商业、盈利等用途。</li>
              <li>6. 您同意不会采用收费或免费的方式，全部或部分地在任何公开场合展示您购买的会员服务内容。</li>
              <li>
                7.
                您同意未经本公司书面授权，不以获取直接或间接经济利益为目的，采用收费或免费的方式，复制、编辑、修改、转载、出版、汇编、发表、引用、传播友邻少年收费内容的任何信息内容。
              </li>
              <li>
                8.
                如因您将课程服务的学习内容部分或者全部公开展示而造成学习内容泄露，侵害其他消费者与本公司及相关权利人的权益时，本公司有权立即暂停您的收听、观看权利；同时根据造成的损失向您请求赔偿；本公司有保留追究内容泄露者的法律责任的权利。
              </li>
            </ul>
          </li>
          <li>
            C. 收费标准
            <ul class="indent">
              <li>
                1.
                一旦您购买了友邻少年的会员套餐服务，即视为您认可该项服务标明之价格，并且自愿承担日后价格变动的风险；您购买成功后，该项服务即时生效。
              </li>
              <li>
                2.
                收费费用标准：友邻少年提供不同价格的会员套餐服务，具体价格以购买时为准，若相关套餐服务有具体协议的，具体协议与协议不一致的部分以具体协议为准。
              </li>
            </ul>
          </li>
          <li>
            D. 友邻月付
            <ul class="indent">
              <li>
                友邻少年为您提供全额付款和分期付款两种付款方式，其中“友邻月付”是友邻少年为您提供的分期付款方式，“友邻月付”的相关内容如下：
                <ul class="indent">
                  <li>
                    1.
                    用户在友邻少年购买有“友邻月付”支付方式的商品时，可以以首付加每月还款的形式按月分期完成付款。商品的首付和每月补款金额及月份数以购买页面展示的内容为准。
                  </li>
                  <li>
                    2.
                    用户需要根据付款界面的提示支付首期服务费，并按照所购产品的付款要求按月完成付款。否则，经过友邻少年合理催告，用户拒不履行月付还款义务的，本公司将于付款日当天暂停您有偿享受的全部权限，即用户协议中付款服务相关条款自动中止，直至还款成功后恢复履行。若逾期连续3个月未还款则已购买权益彻底失效，再次开启权益需重新购买。
                  </li>
                  <li>
                    3.
                    用户在选择“友邻月付”时还需遵守您与第三方代收费平台的代付款协议，若用户逾期付款，除友邻少年会采用第VI条第D款2项约定的措施外，用户可能还会受到第三方支付平台将失信用户报送个人征信机构等失信惩治措施。
                  </li>
                  <li>
                    <u>
                      <b>
                        友邻月付手续费：友邻少年向您提供的“友邻月付”服务含有资金成本、运作成本和风险成本，因此会向您收取一部分手续费。具体金额以实际结算页面为准。
                      </b>
                    </u>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            E. 购买步骤
            <ul class="indent">
              <li>1. 对于具体购买操作步骤，本公司会在友邻少年相关页面上做每一步的明确提示。</li>
              <li>
                2.
                费用支付途径：会员服务费用将在您点击购买之日按照会员套餐购买页面的标示价格通过微信支付、支付宝、财付通、京东支付、快钱、联动优势等第三方代收费的方式支付，
                <u><b>具体支持的支付途径以友邻少年付款界面提示为准。</b></u>
                如您选择用手机话费支付方式提交订单，即视为您同意向支付
                运营商支付通道费，如缴费不成功或者存在其他缴费上的问题，您需与支付运营商进行协商与沟通。
              </li>
            </ul>
          </li>
          <li>
            F. 退款服务
            <ul class="indent">
              <li>
                1.
                退款条件：任何标有“7天内可退款”相关标识的商品，友邻少年均可在用户付款日的7个自然日内提供退款服务，但需同时满足如下条件：
                <ul class="indent">
                  <li>a. 申请退款时间在付款时间的7个自然日内；</li>
                  <li>b. 申请退款的用户听课时长不足180分钟。</li>
                </ul>
              </li>
              <li>
                2.
                退款流程：用户可通过电话或在线咨询的方式向友邻少年提交退款申请，并向服务人员提供必要的支付信息。友邻少年将在您提交申请的5个工作日内反馈审核结果，在审核通过后的10个工作日内完成退款操作。退款金额将返回您支付时所选择的支付渠道。申请退款后将取消您有偿享受的全部权限，用户协议中收费服务的相关条款自动终止。
              </li>
              <li>3. 退款金额：若购买商品中包含实体物品，退款金额将按照该实体物品的售价原价及运费扣除相应金额。</li>
            </ul>
          </li>
          <li>
            G. 服务周期及权限
            <ul class="indent">
              <li>
                1.
                友邻少年会员服务下的内容收听、观看的使用期与您所购买的会员服务期限相同，您一旦购买会员服务即视为认可它的收听、观看服务周期。过期后，音频收听、视频观看权限自动作废，通过友邻少年客户端下载的课程，也将无法使用。
              </li>
              <li>
                2.
                友邻少年可能因营销活动、产品推广等各种原因，在特定时期内推出“限时免费”、“限时优惠”、“限量优惠”以及赠送服务等优惠措施，您需理解并同意，这些优惠措施可能是暂时性、阶段性或有数量限制的，也可能仅适用于满足特定条件的客户，您需按照相应的规则购买、使用相应服务。除非另有书面明确说明，优惠措施不可同时叠加使用。
              </li>
              <li>
                3.
                您在线收听、观看权限：您的收听、观看服务周期不会因其在收听、观看期间对节目的中断、终止、倒回等情况而延长。
              </li>
              <li>
                4.
                一个账号供一个用户使用，如您购买用于2人（包含2人）以上的账号，请购买企业账号。如您购买一人账号用于多人学习，被查处后友邻少年有权立即停止您的收听、观看权限，并在您补缴差额并提供个人信息（包括但不限于身份证复印件信息）后，为您重新开通。
              </li>
              <li>
                5.
                如用户在服务期内恰逢友邻少年开展回馈客户的活动，用户可在符合友邻少年发布的活动规则的情况下享受该等回馈活动。
              </li>
            </ul>
          </li>
          <li>
            H. 发票服务
            <ul class="indent">
              <li>
                1.
                普通用户：普通用户可在付款日的7个工作日后向友邻少年索取发票，友邻少年将在每月25日前为已提交发票索取申请的用户开具发票。
              </li>
              <li>2. 企业用户：企业用户的发票服务以企业与友邻少年签订的采购合同中相关规则为准。</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <h2>VII 免责声明</h2>
    <ul>
      <li>
        A.
        为方便您参考使用，友邻少年可能会提供第三方国际互联网网站或资源链接。您应了解，除非另有声明，友邻少年无法对第三方网站服务进行控制。
        <u><b>您因下载、传播、使用或依赖上述网站或资源所生的损失或损害，应由您自行承担全部责任。</b></u>
      </li>
      <li>
        B. 您应了解，基于不同用户的个人特征和喜好，友邻少年可能存在一些不符合您喜好的内容。
        <u><b>您承诺，不就前述内容追究本公司或第三方的任何责任。</b></u>
      </li>
      <li>
        C.
        <u>
          <b>
            友邻少年不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由友邻少年实际控制的任何网页上的内容，友邻少年不承担任何责任。
          </b>
        </u>
      </li>
      <li>
        D.
        <u><b>网络运行</b></u>
        <ul class="indent">
          <li>1. 友邻少年尽可能保证其稳定运行</li>
          <li>
            2.
            <u><b>您应理解并同意，除非您和本公司另有约定，本公司不会因以下情形出现而对您承担责任</b></u>
            <ul class="indent">
              <li>a. 友邻少年无法使用、或中断使用、或无法完全适合用户的使用要求；</li>
              <li>b. 友邻少年受到干扰，无法及时、安全、可靠运行，或出现任何错误；</li>
              <li>c. 经由友邻少年取得的任何产品、服务（含收费服务）或其他材料不符合您的期望；</li>
              <li>d. 用户资料受到本公司及关联方外的其他任何第三方未经授权的使用或修改。</li>
            </ul>
          </li>
          <li>
            3.
            <u>
              <b>
                友邻少年不对您在本协议项下服务中相关数据的删除或储存失败负责。友邻少年可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。如您停止使用友邻少年，或友邻少年所提供的服务终止或中止，友邻少年可以从服务器上永久地删除用户的数据。友邻少年没有义务向用户返还任何数据。
              </b>
            </u>
          </li>
        </ul>
      </li>
    </ul>
    <h2>VIII 商业活动</h2>
    <ul>
      <li>
        您了解并接受，本公司为维护友邻少年运营，可能进行下述商业活动：
        <ul class="indent">
          <li>A. 通过电子邮件、客户端、网页或其他合法方式向用户发送商品促销或其他相关商业信息；</li>
          <li>
            B.
            通过增值服务系统或其他方式向用户发送的相关服务信息或其他信息，其他信息包括但不限于通知信息、宣传信息、广告信息等。
          </li>
        </ul>
      </li>
    </ul>
    <h2>IX 服务变更、中断或终止</h2>
    <ul>
      <li>
        A.
        如发生下列任何一种情形，友邻少年有权随时中断或终止向用户提供本协议项下的网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任：
        <ul class="indent">
          <li>1. 因法律规定，或本公司服从行政命令或司法判令的要求；</li>
          <li>2. 用户提供的个人资料不真实；</li>
          <li>3. 用户违反本协议中规定的使用规则；</li>
          <li>4. 用户在使用收费网络服务时未按规定向友邻少年支付相应的服务费。</li>
          <li>5. 本公司认为应予终止的其他情形。</li>
        </ul>
      </li>
      <li>
        B. 用户理解，
        <u>
          <b>
            友邻少年需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，友邻少年无需为此承担任何责任,
            但友邻少年应尽可能事先进行通告。
          </b>
        </u>
      </li>
      <li>
        C. 在本协议或本协议项下本公司提供的友邻少年服务（含收费服务）中止或终止时，本公司有权：
        <ul class="indent">
          <li>1. 拒绝用户登录友邻少年；</li>
          <li>2. 删除用户信息；</li>
          <li>3. 删除用户购买的内容。</li>
        </ul>
      </li>
      <li>
        D.
        鉴于网络服务的特殊性，用户同意友邻少年有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，友邻少年无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，友邻少年应当在变更、中断或终止之前事先通知用户，并应向受影响的用户提供等值的替代性的收费网络服务，如用户不愿意接受替代性的收费网络服务，就该用户已经向友邻少年支付的服务费，友邻少年应当按照该用户实际使用相应收费网络服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。
      </li>
      <li>
        E.
        <u><b>您</b></u>
        同意，
        <u>
          <b>
            不因本公司因本协议第九条之约定将所提供的本协议项下友邻少年服务中止或终止，而要求北京每日友邻文化科技有限公司（及关联方）或友邻少年向您作出赔偿或补偿或承担任何其他责任。
          </b>
        </u>
      </li>
    </ul>
    <h2>X 协议变更</h2>
    <ul>
      <li>
        A. 本公司有权根据需要不时地制订、修改本协议，并通过http://www.ylyk.com/
        网站公告或友邻少年APP公告等方式提前予以公布，无需另行单独通知。变更后的协议一经公布后，立即或在公告明确的特定时间自动生效。
        <u>
          <b>
            若您在变更协议生效后继续注册、登录、使用本协议所涉服务的，即表示您阅读、理解并接受经修订的协议，也将遵循变更后的协议使用本公司提供的各项服务。
          </b>
        </u>
      </li>
      <li>
        B.
        如果本协议修改或变更，而您不能接受修改或变更后的内容，本公司的课程服务仍对您合法开放，您可以暂停或停止使用友邻少年，但已支付的费用本公司不予退还。如果您继续使用友邻少年，则表明您完全接受并愿意遵守修改或变更后的协议。
      </li>
      <li>
        C. 本协议中关于课程服务相关条款的修改另有特殊约定的按照该约定处理，未约定的依照本协议第x条之约定进行处理。
      </li>
    </ul>
    <h2>XI 法律责任</h2>
    <ul>
      <li>
        A.
        您应就您所上传的内容承担全部法律责任；无论前述责任是因侵犯第三方权利所引起的，或因您违反与第三方或本协议引起的，或因您违反法律引起的；前述责任包括但不限于对本公司及本公司关联方或第三方所承担的民事责任、行政机关要求承担的行政责任、或刑事责任。
      </li>
      <li>
        B.
        您同意，如因您违反法律规定或本协议规定给本公司或本公司关联方造成损失，您将充分赔偿本公司及本公司关联方所遭受的损失，包括其直接损失、间接损失、预期利益损失等一切损失。
      </li>
      <li>
        C.
        您承诺，如因第三方向您主张权利而导致您承担民事责任、行政责任或刑事责任，您不得以此为理由追究本公司或本公司关联方的责任。
      </li>
      <li>D. 如您应向本公司或本公司关联方承担责任，前述责任不因本协议或本协议项下的服务被终止而免除。</li>
    </ul>
    <h2>XII 其他</h2>
    <ul>
      <li>
        A.
        <b>法律适用</b>
        <ul class="indent">
          <li>1. 您在使用友邻少年时，应遵守中华人民共和国法律。</li>
          <li>2. 本协议的解释及履行应按照中华人民共和国法律进行。</li>
        </ul>
      </li>
      <li>
        B.
        <b>相关协议</b>
        <ul class="indent">
          <li>
            <u>
              <b>
                本公司可能通过友邻少年不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议，您对友邻少年的注册、登录、使用行为将视为您已合法有效地了解并同意相关协议及其修订。
              </b>
            </u>
          </li>
        </ul>
      </li>
      <li>
        C.
        <b>争议解决</b>
        <ul class="indent">
          <li>
            您和本公司均同意，因本协议解释或履行引起的任何争议，双方应首先友好协商解决。
            <u><b>协商不成时，则任一方均可将争议提交北京仲裁委员会依据其届时有效的仲裁规则以仲裁方式解决。</b></u>
            仲裁地点为北京，仲裁语言为中文。
            <u><b>仲裁裁决为终局的，对各方均有法律约束力。请您再次确认您已全部阅读并充分理解上述协议。</b></u>
          </li>
        </ul>
      </li>
      <li>
        D. 本协议中的标题仅为方便及阅读而设，并不影响本协议中任何
        <b>规定的含义或解释。</b>
      </li>
      <li>
        E.
        您和公司均是独立的主体，在任何情况下本协议不构成公司对用户的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
      </li>
    </ul>
    <p class="company">
      <span>北京每日友邻文化科技有限公司</span>
      <span>2020年7月17日</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped>
.body {
  padding: 20px 10px 50px;
  color: #44546a;
}
ul {
  margin-top: 20px;
  margin-left: 10px;
}
ul li {
  list-style: none;
  line-height: 34px;
  font-size: 16px;
}
.indent {
  margin-left: 20px;
}
ul.indent {
  margin-left: 25px;
  margin-top: 0;
}
h1 {
  font-size: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.back {
  width: 25px;
  height: 25px;
}
.empty {
  width: 25px;
  height: 25px;
}
h2 {
  margin-top: 30px;
  font-size: 22px;
}
.company {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin-top: 10px;
}
.link {
  text-decoration: none;
  color: #44546a;
}
</style>
